var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrintAlt = function SvgPrintAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 22h-3.621q-.379 0-.752-.067l-.92-.164c-3.383-.604-5.244-3.076-5.62-5.769-.484-3.466 1.494-7.3 5.861-7.992a.11.11 0 0 0 .08-.053l.636-1.049C13.44 3.982 16.583 3.56 19 4.687c2.378 1.11 4.055 3.722 3.037 6.93a.11.11 0 0 0 .084.142c2.952.586 4.372 3.143 4.173 5.567a5.2 5.2 0 0 1-.915 2.566c-1.353 1.92-4.028 2.1-6.377 2.115-1 .006-2-.007-3.002-.007"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m14.5 22-.5 6h4l-.5-6z"
  })));
};
export default SvgPrintAlt;